import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import Logo from "@/components/store/Logo";

const roleRoute = (role) =>
  ["super_admin", "store_manager", "fulfillment_staff"].includes(role) ? "/admin"
  : role === "affiliate" ? "/affiliate/dashboard" : "/account";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const user = await login(email, password);
      navigate(loc.state?.from || roleRoute(user.role));
    } catch (err) { setError(apiErr(err)); }
    setLoading(false);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16" data-testid="login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10"><Logo /></div>
        <h1 className="font-heading text-4xl tracking-tight text-center mb-2">Welcome Back</h1>
        <p className="font-body text-sm text-ink/60 text-center mb-8">Sign in to continue your voyage.</p>
        {error && <p className="text-sm text-destructive text-center mb-4 font-body" data-testid="login-error">{error}</p>}
        <form onSubmit={submit} className="space-y-6">
          <input data-testid="login-email-input" className="input-luxe" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <input data-testid="login-password-input" className="input-luxe" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          <button data-testid="login-submit-button" className="btn-primary w-full" disabled={loading}>{loading ? "Signing in…" : "Sign In"}</button>
        </form>
        <p className="font-body text-sm text-ink/60 text-center mt-6">New here? <Link to="/register" data-testid="login-register-link" className="underline hover:text-ink">Create an account</Link></p>
      </div>
    </div>
  );
}
